module.exports = __webpack_public_path__ + "img/other.77c06d11.png";